import { motion } from "framer-motion";
import { Star, Instagram, Facebook } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const ICONS = [Star, Instagram, Facebook];

const AboutUs = () => {
  const { t } = useLang();
  const a = t.about;

  return (
    <section id="about" className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32" data-testid="about-section">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
        <div className="lg:col-span-5">
          <motion.div
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:sticky lg:top-28">
            <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-accent/30 bg-accent/5 px-4 py-1.5 text-sm font-medium text-secondary">
              <span className="h-2 w-2 rounded-full bg-accent" /> {a.title}
            </span>
            <h2 className="font-heading text-4xl font-bold leading-tight tracking-tight text-primary lg:text-5xl">
              {a.lead}
            </h2>
          </motion.div>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <div className="space-y-6 text-lg leading-relaxed text-muted-foreground">
            {a.p.map((para, i) => (
              <motion.p key={i}
                initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.55, delay: i * 0.08 }}>
                {para}
              </motion.p>
            ))}

            <div className="space-y-3 pt-2">
              {a.features.map((f, i) => {
                const Icon = ICONS[i];
                return (
                  <motion.div key={i}
                    initial={{ opacity: 0, x: 24 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: i * 0.1 }}
                    className="flex items-center gap-4 rounded-xl border border-border bg-card p-4"
                    data-testid={`about-feature-${i}`}>
                    <span className="grid h-11 w-11 shrink-0 place-items-center rounded-lg bg-secondary text-white">
                      <Icon className="h-5 w-5" />
                    </span>
                    <p className="text-base text-foreground">
                      <span className="font-heading font-semibold text-primary">{f.t}</span>
                      <span className="text-muted-foreground"> — {f.d}</span>
                    </p>
                  </motion.div>
                );
              })}
            </div>

            <motion.div
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="pt-4">
              <p className="text-base text-muted-foreground">{a.closing1}</p>
              <p className="mt-3 font-heading text-3xl font-bold tracking-tight">
                {a.closing2.trim().split(" ").map((word, i) => (
                  <span key={i} className={["text-primary", "text-secondary", "text-accent"][i % 3]}>{word} </span>
                ))}
              </p>
            </motion.div>

            {/* Tijdelijk verborgen op verzoek — EUB-NFC-pods blok (tekst bewaard in i18n about.extraP/extraClosing).
            <motion.div
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="mt-6 space-y-5 border-t border-border pt-8" data-testid="about-eub">
              {a.extraP.map((para, i) => (
                <p key={i} className="text-lg leading-relaxed text-muted-foreground">{para}</p>
              ))}
              <p className="font-heading text-2xl font-semibold text-secondary">{a.extraClosing}</p>
            </motion.div>
            */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
